import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <div
      data-testid="notfound-page"
      className="section-pad flex min-h-[60vh] items-center"
    >
      <div className="container-hh max-w-xl text-center">
        <p className="eyebrow">Page not found</p>
        <h1 className="mt-3 text-5xl md:text-6xl">This page took the day off.</h1>
        <p className="mt-5 text-lg leading-relaxed text-bodytext">
          The page you're looking for isn't here — but your time back is just a
          click away. Let's get you home.
        </p>
        <Link to="/" data-testid="notfound-home-btn" className="btn-teal mt-8">
          <Home className="h-5 w-5" /> Back to home
        </Link>
      </div>
    </div>
  );
}
